(function (window, document, $, undefined) {
    if (typeof $ === 'undefined') {
        throw new Error('JQUERY is required. You better check the CDN links.  Houston, we have a problem.');
    }

    $(function () {

        // PAGE IS LOADED NOW GO AWAY
        hideLoading();

        // SHOW LOADING WHEN THE USER NAVIGATES AWAY
        window.onbeforeunload = function () {
            showLoading();
        };

    }); // doc ready
})(window, document, window.jQuery);
